import React from 'react'
import { CorporateNav, SiteNavigation } from 'react-dxd-components'

export default function AppHeader () {
  return <>
    <div data-testid='app-header' className='nav-container'>
      <CorporateNav logoLinkText={null} logoLink='' />
      <SiteNavigation applicationName='Evidence of Insurability' fullWidth />
    </div>
  </>
}